import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

export default function withAuthorizationRouter(Component) {
  class AuthenticatedComponent extends React.Component {
    render() {
      const { isAuthenticated, showOTPVerification, isAuthenticatedGuest } = this.props;
      const redirectAfterLogin = this.props.location.pathname; // eslint-disable-line
      const slug = this.props.location.search || null; // eslint-disable-line
      const authenticating = (isAuth, isOTP, isGuest) => {
        if (isOTP) {
          return <Redirect to='/auth/otp' />;
        }

        if (
          isGuest === true &&
          redirectAfterLogin !== '/app/home' &&
          // eslint-disable-next-line react/prop-types
          !redirectAfterLogin.includes('/app/directory') &&
          redirectAfterLogin !== '/app/about-us' &&
          redirectAfterLogin !== '/app/authorization-service' &&
          redirectAfterLogin !== '/app/lease-service' &&
          redirectAfterLogin !== '/app/dircetory-service' &&
          redirectAfterLogin !== '/app/sale-service' &&
          redirectAfterLogin !== '/app/certificate-service' &&
          redirectAfterLogin !== '/app/company-service' &&
          // redirectAfterLogin !== '/app/term-and-condition' &&
          redirectAfterLogin !== '/app/adgm-offices' &&
          redirectAfterLogin !== '/app/adgm-at-your-place' &&
          redirectAfterLogin !== '/app/privacy-policy' &&
          redirectAfterLogin !== '/app/contact-us' &&
          redirectAfterLogin !== '/app/verify-documents' &&
          redirectAfterLogin !== '/app/marketdata' &&
          redirectAfterLogin !== '/app/market-data-mobile' &&
          redirectAfterLogin !== '/app/market-data-detail'
        ) {
          if (isAuth === false || isAuth == null) {
            if (slug) {
              localStorage.setItem('redirect_url', redirectAfterLogin + slug);
            } else {
              localStorage.setItem('redirect_url', redirectAfterLogin);
            }

            return <Redirect to={`/login?next=${redirectAfterLogin}`} />;
          }
        }

        return <Component {...this.props} />;
      };

      return <div>{authenticating(isAuthenticated, showOTPVerification, isAuthenticatedGuest)}</div>;
    }
  }

  AuthenticatedComponent.propTypes = {
    isAuthenticated: PropTypes.bool,
    showOTPVerification: PropTypes.bool,
    isAuthenticatedGuest: PropTypes.bool,
  };

  AuthenticatedComponent.defaultProps = {
    isAuthenticated: null,
    showOTPVerification: false,
    isAuthenticatedGuest: false,
  };

  const mapStateToProps = state => ({
    isAuthenticated: state.authReducer.loggedIn,
    isAuthenticatedGuest: state.authReducer.guestLoggedIn,
    showOTPVerification: state.authReducer.showOTPVerification,
    ...state,
  });

  return connect(mapStateToProps)(AuthenticatedComponent);
}
